export function gain_produce(pid) {
	if (pid) {

		let temp_produce = false;
		for (let i in produce) {
			if (produce[i]['p_id'] === pid) {
				temp_produce = produce[i];
				break;
			}
		}

		switch (temp_produce['p_id']) {
			//标准红包
			case 'pidredenv_hbhb': {
				temp_produce['table'] = createPid_hbhb();
				break;
			}
			//专版红包
			case 'pidredenv_zbhb': {
				temp_produce['table'] = createPid_zbhb();
				break;
			}
		}

		return temp_produce;
	}
}

const produce = [
	{ p_id: 'pidredenv_hbhb', choose: false, p_name: '标准红包' },
	{ p_id: 'pidredenv_zbhb', choose: false, p_name: '专版红包' },
]

// 标准红包
function createPid_hbhb() {
	return {
		// 成品尺寸
		p_leixing: {
			name: '类型',
			container: 'leixing',
			data: [
				{ type: 'default', name: '彩印红包', value: '彩印红包', choose: true },
				{ type: 'default', name: '特种纸烫金红包', value: '特种纸烫金红包', choose: false },
				{ type: 'default', name: '现货红包', value: '现货红包', choose: false },
			]
		},
		p_chengpinchicun: {
			name: '成品尺寸',
			container: ['xx', 'yy', 'chichunstr', 'chichun'],
			data: [
				{ type: 'default', name: '大号(88*165)', value: [187, 215, '大号(88*165)'], choose: true },
				{ type: 'default', name: '小号(80*120)', value: [171, 162, '中号(80*120)'], choose: false },
				// { type: 'default', name: '小号(88*105)', value: [195, 132, '小号(88*105)'], choose: false },
				{
					type: 'custom2',
					name: '自定义展开尺寸',
					value: [187, 215, '展开尺寸:187×215', '187*215', '1'],
					choose: false,
				},
			]
		},
		// 刀模
		p_daomo: {
			name: '刀模',
			container: 'daomo',
			data: [
				{ type: 'default', name: '标准-元宝舌', value: '0', choose: true },
				{ type: 'default', name: '标准-圆舌', value: '0', choose: false },
				// { type: 'default', name: '定制刀模', value: '1', choose: false },
			]
		},
		p_zhizhangkezhong: {
			name: '纸张克重',
			container: ['cailiao', 'yongzhi'],
			data_multi: [
				{
					type: 'select',
					name: '双铜纸',
					value: '1',
					choose: true,
					level: '1',
					select_show: false,
					select_data: [
						{ name: '双铜纸', value: '1' },
						{ name:'单铜纸(白卡纸)',value:'2'},
						{ name: '红包艺术纸', value: '20350' },
						{ name: '单面珠光冰白', value: '20579' },
					],
				},
				{
					type: 'select',
					name: '157克',
					value: '157',
					choose: true,
					level: '2',
					select_show: false,
					select_data: [
						{ name: '157克', value: 157 },
						{ name: '200克', value: 200 },
					],
				},
			],
			multi_list: [
				// 双铜纸
				[
					{ name: '157克', value: 157 },
					{ name: '200克', value: 200 },
				],
				[
					{ name: '215克', value: '210' }],
				[{ name: '150克', value: '150' }],
				[
					{ name: '160克', value: '160' }],
				
			],
		},
		// 印刷款数
		p_kuanshu: {
			name: '印刷款数',
			container: 'pinzhong',
			data: [
				{ type: 'default', name: '1', value: 1, choose: true, },
				{ type: 'default', name: '2', value: 2, choose: false, },
				{ type: 'default', name: '3', value: 3, choose: false, },
				{ type: 'default', name: '4', value: 4, choose: false, },
				{ type: 'default', name: '5', value: 5, choose: false, },
				{ type: 'default', name: '6', value: 6, choose: false, },
				{ type: 'default', name: '7', value: 7, choose: false, },
				{ type: 'custom1', name: '', value: 9, choose: false, },
			],
		},
		// 印刷数量
		p_yinshuashuliang: {
			name: '印刷数量',
			container: 'shuliang',
			data: [
				{ type: 'default', name: '1000', value: 1000, choose: true },
				{ type: 'default', name: '2000', value: 2000, choose: false },
				{ type: 'default', name: '3000', value: 3000, choose: false },
				{ type: 'default', name: '5000', value: 5000, choose: false },
				{ type: 'default', name: '10000', value: 10000, choose: false },
				{ type: 'default', name: '20000', value: 20000, choose: false },
				{ type: 'custom1', name: '', value: 20000, choose: false },
			]
		},
		// 印刷颜色
		p_yinshuayanse: {
			name: '印刷颜色',
			container: 'ysys',
			data: [
				{ type: 'default', name: '彩色', value: '4', choose: true },
				// { type: 'default', name: '无', value: '0', choose: false },
			]
		},
		//后道工序
		p_houdaogongxu: {
			name: '后道工序',
			data_after: [

				{
					container: 'bmcl',
					must: false,
					data: [
						{
							type: 'select',
							name: '单面哑膜',
							value: '8657',
							choose: true,
							select_show: false,
							select_data: [
								{ name: '单面亮膜', value: '8656' },
								{ name: '单面哑膜', value: '8657' },
								{ name: '单面触感膜', value: '4292' },
								{ name: '单面防刮花哑膜', value: '防刮花哑膜' },
							],
						},
					],
				},
				{
					container: 'hjgzdy0',
					must: false,
					reduce: false,
					data: [
						{ type: 'default', name: '过光油', value: '4217', choose: false },
					]
				},
				{
					container: ['tjx', 'tjy', 'tangCl', 'hjg'],
					must: false,
					data: [
						{
							type: 'select',
							custom2: true,
							unit: 'mm',
							name: '普通平烫',
							value: [150, 150, '25552', '烫金'],
							choose: false,
							select_show: false,
							select_data: [
								{
									name: '普通平烫',
									value: [150, 150, '25552', '烫金'],
								},
								{
									name: '浮雕烫',
									value: [150, 150, '25551', '烫金'],
								},
							],
						},
					],
				},
				{
					container: 'tjys',
					must: false,
					data: [
						{
							type: 'select', name: '烫黄金', value: '烫金', choose: false, select_show: false, select_data: [
								{ name: '烫黄金', value: '烫金' },
								{ name: '烫哑金', value: '烫金' },
								{ name: '烫红金', value: '烫金' },
								{ name: '烫蓝金', value: '烫金' },
								{ name: '烫黑金', value: '烫金' },
								{ name: '烫银', value: '烫金' },
								{ name: '烫特殊颜色金', value: '烫金' },
							]
						}
					]
				},
				{
					container: ['jtx', 'jty', 'hjg', 'jtCl'],
					must: false,
					data: [
						{
							type: 'select',
							custom2: true,
							unit: 'mm',
							name: '普通击凸版',
							value: [120, 120, '击凸', '25548'],
							choose: false,
							select_show: false,
							select_data: [
								{ name: '普通击凸版', value: [120, 120, '击凸', '25548'], },
								{ name: '加厚击凸版', value: [120, 120, '击凸', '25549'], },
							],
						},
					],
				},
				{
					container: 'hjg',
					must: true,
					reduce: true,
					data: [
						{ type: 'default', name: '模切', value: '模切', choose: true },
					]
				},
				{
					container: 'hjg',
					must: true,
					data: [
						{ type: 'default', name: '粘', value: '粘成品', choose: true },
					]
				},
				{
					container: ['jdgs', 'hjg'],
					must: false,
					data: [
						{
							type: 'select', name: '装胶袋-10个(一袋)', value: ['10', '装胶袋'], choose: false, select_show: false, select_data: [

								{ name: '装胶袋-5个(一袋)', value: [5, '装胶袋'] },
								{ name: '装胶袋-6个(一袋)', value: [6, '装胶袋'] },
								{ name: '装胶袋-8个(一袋)', value: [8, '装胶袋'] },
								{ name: '装胶袋-10个(一袋)', value: [10, '装胶袋'] },
							]
						},
					]
				},
				{
					container: 'zhzd',
					must: false,
					data: [
						{
							type: 'select',
							name: '扎红纸带-100个/扎',
							value: '扎红纸带-100个/扎',
							choose: false,
							select_show: false,
							select_data: [
								{ name: '扎红纸带-100个/扎', value: '100' },
								{ name: '扎红纸带-50个/扎', value: '50' },
							],
						},
					]
				},
			]
		}
	}
}

// 专版红包
function createPid_zbhb() {
	return {
		// 成品尺寸
		p_chengpinchicun: {
			name: '成品尺寸',
			container: ['xx', 'yy', 'chichun', 'chichunstr', 'isdiy'],
			data: [
				{ type: 'default', name: '小号(88*105)', value: [195, 132, '195*132', '利是封(88×105)', ''], choose: true },
				{ type: 'default', name: '中号(80*120)', value: [175, 165, '175*165', '利是封(80×120)', ''], choose: false },
				{ type: 'default', name: '大号(88*165)', value: [195, 205, '195*205', '利是封(88×165)', ''], choose: false },
				{ type: 'custom2', name: '自定义展开尺寸', value: [195, 205, '195*205', '展开尺寸:195×205', '1'], choose: false },
			]
		},
		p_zhizhangkezhong: {
			name: '纸张克重',
			container: ['cailiao', 'yongzhi'],
			data_multi: [
				{
					type: 'select', name: '双铜纸', value: '1', choose: true, level: '1', select_show: false, select_data: [
						{ name: '双铜纸', value: '1' },
						{ name: '双胶纸', value: '5' },
						{ name: '白牛皮', value: '14' },
						{ name: '哑粉纸', value: '3' },
						{ name: '鲜红闪金', value: '11852' },
						{ name: '灵感珠光大红', value: '11853' },
						{ name: '意象触感红', value: '11854' },
					]
				},
				{
					type: 'select', name: '157克', value: 157, choose: true, level: '2', select_show: false, select_data: [
						{ name: '105克', value: 105 },
						{ name: '128克', value: 128 },
						{ name: '157克', value: 157 },
						{ name: '200克', value: 200 },
						{ name: '250克', value: 250 },
					]
				},
			],
			multi_list: [
				// 双铜纸
				[
					{ name: '105克', value: 105 },
					{ name: '128克', value: 128 },
					{ name: '157克', value: 157 },
					{ name: '200克', value: 200 },
					{ name: '250克', value: 250 },
				],
				// 双胶纸
				[
					{ name: '100克', value: 100 },
					{ name: '120克', value: 120 },
					{ name: '140克', value: 140 },
					{ name: '160克', value: 160 },
					{ name: '200克', value: 200 },
					{ name: '250克', value: 250 },
				],
				// 白牛皮
				[
					{ name: '100克', value: 100 },
					{ name: '120克', value: 120 },
					{ name: '150克', value: 150 },
					{ name: '180克', value: 180 },
					{ name: '200克', value: 200 },
					{ name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
				],
				// 哑粉纸
				[
					{ name: '105克', value: 105 },
					{ name: '128克', value: 128 },
					{ name: '157克', value: 157 },
					{ name: '200克', value: 200 },
					{ name: '250克', value: 250 },
				],
				// 鲜红闪金
				[
					{ name: '120克', value: 120 },
				],
				// 灵感珠光大红
				[
					{ name: '120克', value: 120 },
				],
				// 意象触感红
				[
					{ name: '120克', value: 120 },
				],

			]
		},
		// 刀模
		p_daomo: {
			name: '刀模',
			container: 'daomo',
			data: [
				{ type: 'default', name: '标准刀模', value: '0', choose: true },
				{ type: 'default', name: '定制刀模', value: '1', choose: false },
			]
		},
		// 印刷数量
		p_yinshuashuliang: {
			name: '印刷数量',
			container: 'shuliang',
			data: [
				{ type: 'default', name: '1000', value: 1000, choose: true },
				{ type: 'default', name: '2000', value: 2000, choose: false },
				{ type: 'default', name: '3000', value: 3000, choose: false },
				{ type: 'default', name: '5000', value: 5000, choose: false },
				{ type: 'default', name: '10000', value: 10000, choose: false },
				{ type: 'default', name: '20000', value: 20000, choose: false },
				{ type: 'custom1', name: '', value: 20000, choose: false },
			]
		},
		// 印刷颜色
		p_yinshuayanse: {
			name: '印刷颜色',
			container: 'ysys',
			data: [
				{ type: 'default', name: '彩色', value: '4', choose: true },
				{ type: 'default', name: '双色', value: '2', choose: false },
				{ type: 'default', name: '单色', value: '1', choose: false },
				{ type: 'default', name: '无', value: '0', choose: false },
			]
		},
		//后道工序
		p_houdaogongxu: {
			name: '后道工序',
			data_after: [
				{
					container: 'hjg',
					must: true,
					reduce: true,
					data: [
						{ type: 'default', name: '模切', value: '模切', choose: true },
					]
				},
				{
					container: 'hjg',
					must: true,
					data: [
						{ type: 'default', name: '粘', value: '粘成品', choose: true },
					]
				},
				{ container: '', must: true, data: [] },
				{
					container: 'hjg',
					must: false,
					data: [
						{ type: 'default', name: '单面亮膜', value: '单面覆亮膜', choose: false },
						{ type: 'default', name: '单面哑膜', value: '单面覆哑膜', choose: false },
					]
				},
				{
					container: 'hjg',
					must: false,
					data: [
						{ type: 'default', name: '带自粘(涂口水胶)', value: '带自粘', choose: false },
					]
				},
				{
					container: ['hjgzdy0', 'hjgother'],
					must: false,
					data: [
						{ type: 'default', name: '过光油', value: ['4217', '1'], choose: false },
					]
				},
				{
					container: ['tjx', 'tjy', 'hjg'],
					must: false,
					data: [
						{
							type: 'select', custom2: true, unit: 'mm', name: '烫黄金', value: [10, 10, '烫金/银'], choose: false, select_show: false, select_data: [
								{ name: '烫黄金', value: [10, 10, '烫金/银'] },
								{ name: '烫银', value: [10, 10, '烫金/银'] },
								{ name: '烫红金', value: [10, 10, '烫金/银'] },
								{ name: '烫哑金', value: [10, 10, '烫金/银'] },
								{ name: '烫蓝金', value: [10, 10, '烫金/银'] },
								{ name: '烫黑金', value: [10, 10, '烫金/银'] },
								{ name: '烫指定颜色金', value: [10, 10, '烫金/银'] },
							]
						},
					]
				},
				{
					container: ['jtx', 'jty', 'hjg'],
					must: false,
					data: [
						{ type: 'custom2', name: '击凸', value: [10, 10, '击凸'], choose: false },
					]
				},
				{
					container: ['jdgs', 'hjg'],
					must: false,
					data: [
						{
							type: 'select', name: '装胶袋-1个(一袋)', value: [1, '装胶袋'], choose: false, select_show: false, select_data: [
								{ name: '装胶袋-1个(一袋)', value: [1, '装胶袋'] },
								{ name: '装胶袋-5个(一袋)', value: [5, '装胶袋'] },
								{ name: '装胶袋-6个(一袋)', value: [6, '装胶袋'] },
								{ name: '装胶袋-8个(一袋)', value: [8, '装胶袋'] },
								{ name: '装胶袋-10个(一袋)', value: [10, '装胶袋'] },
								{ name: '装胶袋-20个(一袋)', value: [20, '装胶袋'] },
							]
						},
					]
				},
			]
		}
	}
}



// WEBPACK FOOTER //
// ./src/seal/proRedEnvelopes.js